import Badge from "@/components/core/badge";
import DragDropFile from "@/components/core/forms/drag-drop-file";
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from "@/components/core/tabs.tsx";
import { useAuth } from "@/hooks/use-auth";

type CaseEvidenceProps = {
	type: "plaintiff" | "defendant";
};

export const CaseEvidence = ({ type }: CaseEvidenceProps) => {
	const isPlaintiff = type === "plaintiff";
	const { user } = useAuth();
	const occ = user?.is_occ;
	return (
		<div className="flex flex-col w-full border-b last:border-b-0 border-dashed">
			<div className="flex flex-row justify-between w-full gap-4 p-4 ">
				<div className="inline-flex flex-row items-center gap-1">
					<Badge size="sm" color={isPlaintiff ? "blue" : "red"}>
						{isPlaintiff ? "P" : "D"}
					</Badge>
					<Badge size="sm" color="gray-light">
						Main
					</Badge>
				</div>
			</div>
			<div className="flex flex-col w-full">
				<Tabs
					variant="compact"
					defaultValue="documents"
					orientation="horizontal"
				>
					<TabsList>
						<TabsTrigger value="documents">Documents (0)</TabsTrigger>
						<TabsTrigger value="testimonial">Testimonial (0)</TabsTrigger>
						<TabsTrigger value="object">Object (0)</TabsTrigger>
					</TabsList>
					<TabsContent value="documents">
						{/* {!occ && <DragDropFile />} */}
						<DragDropFile />
					</TabsContent>
					<TabsContent value="testimonial">
						{/* {!occ && <DragDropFile />} */}
						<DragDropFile />"
					</TabsContent>
					<TabsContent value="object">{!occ && <DragDropFile />}</TabsContent>
				</Tabs>
			</div>
		</div>
	);
};
